import Constants from '../../Constants';
import {
  LISTING_SELECT_CARD,
  LISTING_DESELECT_CARD,
  LISTING_SET_LAYOUT,
  LISTING_SET_CURRENT_PAGE,
  LISTING_SET_TOTAL_PAGES,
  LISTING_SET_TOTAL_ITEMS,
  LISTING_RESET_PAGE_NUMBERS,
  LISTING_SET_SORT_CRITERIA,
  LISTING_SET_ACL_QUERY_MODE,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';
import { ACLQueryModeTypes } from '../../constants/visibilityFilters';

const initialState = {
  selectedCardId: 0,
  layout: Constants.ListingLayouts.LIST,
  currentPage: 1,
  totalPages: 0,
  totalItems: 0,
  sortCriteria: Constants.SortCriteria.LAST_CREATED_DESC,
  aclQueryMode: ACLQueryModeTypes.MODE_OWNER.key,
};

export const listingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LISTING_SELECT_CARD:
      return selectCard(state, action);

    case LISTING_DESELECT_CARD:
      return deselectCard(state, action);

    case LISTING_SET_LAYOUT:
      return setLayout(state, action);

    case LISTING_SET_CURRENT_PAGE:
      return setCurrentPage(state, action);

    case LISTING_SET_TOTAL_PAGES:
      return setTotalPages(state, action);

    case LISTING_SET_TOTAL_ITEMS:
      return setTotalItems(state, action);

    case LISTING_RESET_PAGE_NUMBERS:
      return resetPageNumbers(state, action);

    case LISTING_SET_SORT_CRITERIA:
      return setSortCriteria(state, action);

    case LISTING_SET_ACL_QUERY_MODE:
      return setAclQueryMode(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function selectCard(state, action) {
  return {
    ...state,
    selectedCardId: action.payload.id,
  };
}

function deselectCard(state, action) {
  return {
    ...state,
    selectedCardId: initialState.selectedCardId,
  };
}

function setLayout(state, action) {
  return {
    ...state,
    layout: action.payload.layout,
  };
}

function setCurrentPage(state, action) {
  return {
    ...state,
    currentPage: action.payload.currentPage,
  };
}

function setTotalPages(state, action) {
  return {
    ...state,
    totalPages: action.payload.totalPages,
  };
}

function setTotalItems(state, action) {
  return {
    ...state,
    totalItems: action.payload.totalItems,
  };
}

function resetPageNumbers(state, action) {
  return {
    ...state,
    currentPage: initialState.currentPage,
    totalPages: initialState.totalPages,
  };
}

function setSortCriteria(state, action) {
  return {
    ...state,
    sortCriteria: action.payload.sortCriteria,
  };
}

function setAclQueryMode(state, action) {
  return {
    ...state,
    aclQueryMode: action.payload.aclQueryMode,
  };
}

export default listingReducer;
